<ng-container [formGroup]="form">
  <mat-checkbox formControlName="filterByDateRange">Filter by Date Range</mat-checkbox>
  <mat-form-field [class.disable-style]="!form.controls.filterByDateRange.value">
    <input
      [disabled]="!form.controls.filterByDateRange.value"
      autocomplete="off"
      formControlName="field"
      type="text"
      [lcsSingleSelect]="fieldSelect"
      lcsStaticSelect
      [lcsStaticSelectValue]="form.get('field')?.value"
      required
      />
      @if (form.controls.field.hasError('required')) {
        <mat-error> Please select date range to filter by </mat-error>
      }
      <lcs-static-select #fieldSelect [displayWith]="displayWith">
        @for (field of dateRangeFields; track field) {
          <lcs-option [value]="field">
            {{ field }}
          </lcs-option>
        }
      </lcs-static-select>
    </mat-form-field>

    <mat-form-field floatLabel="always" [class.disable-style]="!form.controls.filterByDateRange.value">
      <mat-label> {{ label ?? 'Date Range' | async }} </mat-label>
      <lcs-date-range-picker-input
        [disabled]="!form.controls.filterByDateRange.value"
        [required]="true"
        [initialContentFormValue]="contentFormValue"
        (contentFormValueChange)="onContentFormValueChange($event)"
        >
        <input lcsStartDate formControlName="startDate" />
        <input lcsEndDate formControlName="endDate" />
      </lcs-date-range-picker-input>
      <mat-error> Please select a date range </mat-error>
    </mat-form-field>
  </ng-container>
